import { OfficeEntity, OfficesOrder } from "../../../entities";
export const OfficeRegistrationRequestSchema = OfficeEntity.schema.pick({
    name: true,
    postalCode: true,
    address: true,
    telephoneNumber: true,
    faxNumber: true,
    mailAddress: true,
});
export const OfficeInitRegistrationRequestSchema = OfficeEntity.schema.pick({
    id: true,
    name: true,
    postalCode: true,
    address: true,
    telephoneNumber: true,
    faxNumber: true,
    mailAddress: true,
    version: true,
});
export const OfficeUpdateRequestSchema = OfficeEntity.schema.pick({
    name: true,
    postalCode: true,
    address: true,
    telephoneNumber: true,
    faxNumber: true,
    mailAddress: true,
    version: true,
});
export const OfficeUpdateOrderRequestSchema = OfficesOrder.schema.partial({
    version: true,
});
//# sourceMappingURL=office-request.js.map